export const Logo = () => {
  return (
    <span className="font-redhat text-2xl whitespace-nowrap tracking-wide">Enryched</span>
  );
};
